import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=b4604308&scoped=true&"
import script from "./EditTable.vue?vue&type=script&lang=js&"
export * from "./EditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4604308",
  null
  
)

export default component.exports